import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { FeatureModalService } from '../../feature-modal/feature-modal.service';
import { GlobalSubscriptionService } from '../../subscriptions/global-subscription.service';

@Component({
  selector: 'app-document-item-track-inventory',
  templateUrl: './document-item-track-inventory.component.html',
  styleUrls: ['./document-item-track-inventory.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentItemTrackInventoryComponent implements OnInit, OnDestroy {
  form: FormGroup;
  @Input()
  set disabled(disable: boolean) {
    if (this.form) {
      this.form.controls.trackInventory[disable ? 'disable' : 'enable']();
    }
    this._disabled = disable;
  }
  get disabled(): boolean {
    return this.form.controls.trackInventory.disabled;
  }
  @Input() trackInventory: boolean;
  @Output() toggle = new EventEmitter<boolean>();

  _disabled: boolean;
  hasInventoryAddon: Observable<boolean>;
  private onDestroy: Subject<void> = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    private featureModalService: FeatureModalService,
    private globalSubscriptionService: GlobalSubscriptionService,
  ) {}

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      trackInventory: [this.trackInventory],
    });

    if (this._disabled) {
      this.form.controls.trackInventory.disable();
    }

    this.hasInventoryAddon = this.globalSubscriptionService
      .has('inventory')
      .pipe(take(1)) as Observable<boolean>;

    combineLatest([
      this.hasInventoryAddon,
      this.form.controls.trackInventory.valueChanges,
    ])
      .pipe(takeUntil(this.onDestroy))
      .subscribe(([hasInventoryAddon, value]) => {
        if (hasInventoryAddon) {
          this.toggle.emit(value);
        } else if (value) {
          this.form.controls.trackInventory.setValue(false, {
            emitEvent: false,
            onlySelf: true,
          });
          this.featureModalService.open('inventory');
        }
      });
  }
}
